import {defineAsyncComponent} from 'vue';
import popupUtil from '@/commons/popupUtil.js';

// List
const InInwardTab = defineAsyncComponent(() => import('@/views/tools/inInward/INInwardList.vue'));
const InOutwardTab = defineAsyncComponent(() => import('@/views/tools/inOutwardTab/InOutwardList.vue'));
const suIncrementList = defineAsyncComponent(() => import('@/views/tools/suIncrement/SuIncrementList.vue'));
const SUDecrementList = defineAsyncComponent(() => import('@/views/tools/suDecrement/SUDecrementList.vue'));
const inTransferList = defineAsyncComponent(() => import('@/views/tools/inTransfer/INTransferList.vue'));
const SUTransferList = defineAsyncComponent(() => import('@/views/tools/suTransfer/SUTransferList.vue'));
// Detail
const suIncrementDetail = defineAsyncComponent(() => import('@/views/tools/suIncrement/SuIncrementDetail.vue'));
const suDecrementDetail = defineAsyncComponent(() => import('@/views/tools/suDecrement/SUDecrementDetail.vue'));
const inTransferDetail = defineAsyncComponent(() => import('@/views/tools/inTransfer/INTransferDetail.vue'));
const popupInwardDetail = defineAsyncComponent(() => import('@/views/tools/inInward/INInwardDetail.vue'));
const suTransferDetail = defineAsyncComponent(() => import('@/views/tools/suTransfer/SUTransferDetail.vue'));
export const registerTools = app => {
  const registerConfig = {
    INTransferList: inTransferList,
    InventoryTransferDetail: inTransferDetail,
    SuIncrementList: suIncrementList,
    ToolIncrementDetail: suIncrementDetail,
    INInwardDetail: popupInwardDetail,
    SUTransferDetail: suTransferDetail,
    SUDecrementList: SUDecrementList,
    SUDecrementDetail: suDecrementDetail,
    InInwardTab: InInwardTab,
    InOutwardTab: InOutwardTab,
    SUTransferList: SUTransferList,
  };

  const keys = Object.keys(registerConfig);

  keys.filter(key => {
    app.component(key, registerConfig[key]);
  });

  popupUtil.registerPopup(keys, 'Tools');
};
